var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHamburgerRedux = function SvgHamburgerRedux(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 17.25a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1 0-1.5h12Zm6-6a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1 0-1.5h18Zm0-6a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1 0-1.5h18Z",
    fill: "#273943"
  })));
};
export default SvgHamburgerRedux;